import Utils from "../Utils";
import Browser from "./Browser";
import removeValidationTooltip from "./removeValidationTooltip";
import focusInput from "./focusInput";
import setPlaceholder from "./setPlaceholder";

const enableTypingInput = (me, inputContainerSelector, instruction) => {
    // CHAT-7038: enable input
    if (!inputContainerSelector) return;
    const input = typeof inputContainerSelector === 'string' ? me.context.querySelector(inputContainerSelector) : inputContainerSelector;
    const textAreaExists = input.getElementsByTagName('textarea')[0]; // check text area exists or not
    const autoCompleteExists =
        me.options.elements &&
        me.options.elements.autoCompleteInput &&
        me.context.querySelector(me.options.elements.autoCompleteInput);
    if (Browser.isAndroid() || Browser.isiOS()) {
        if (textAreaExists) {
            input.querySelector('textarea')?.classList.remove('livechat_disabledcaret')
            Utils.allowTyping(input);
        } else {
            input.classList.remove('livechat_disabledcaret')
            Utils.allowTyping(input); //allow user to type when input field enabled                           
        }
    }
    if (Browser.isiOS()) {
        // Bug-CHAT-7468 Jquery focus does not open keyboard for IOS devices so its not useful for us.
        if (textAreaExists) {
            removeValidationTooltip(input, { toolTipCss: 'livechat_validation_tooltip' })
            Utils.enableElement(input, { applyGrayBackground: true })
            Utils.enableElement(input.getElementsByTagName('textarea')[0]);
        } else {
            Utils.enableElement(removeValidationTooltip(input, { toolTipCss: 'livechat_validation_tooltip' }))
        }
    } else if (textAreaExists) {
        removeValidationTooltip(input, { toolTipCss: 'livechat_validation_tooltip' })
        Utils.enableElement(input, { applyGrayBackground: true })
        var area = Utils.enableElement(input.getElementsByTagName('textarea')[0]);
        area.focus();


    } else {
        removeValidationTooltip(input, { toolTipCss: 'livechat_validation_tooltip' })
        //.first()
        Utils.enableElement(input)
        input.focus();
    }
    if (autoCompleteExists) {
        me.context.querySelector(me.options.elements.autoCompleteInput).focus();
    }
    if (instruction) {
        setPlaceholder(input, instruction);
    }
    if (input) {
        input.removeEventListener('click', focusInput);
        input.addEventListener('click', focusInput);
    }
}
export default enableTypingInput;